export default {
  "content": "<path d=\"M9.386 11.85L5.971 8.528a.749.749 0 010-1.059L9.386 4.15a.5.5 0 01.715 0 .5.5 0 01.146.352l.001 6.994a.5.5 0 01-.31.465.5.5 0 01-.552-.111z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};